import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { earningsQKeys } from "@hooks/queries/earnings/queryKeys";

export interface RequestPayoutPayload {
  payout_type: string;
  payout_method: string;
  mobile_money_number?: string;
  bank_account_number?: string;
  bank_name?: string;
  period_start?: string;
  period_end?: string;
  notes?: string;
}

export const useRequestPayout = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: async (payload: RequestPayoutPayload) => {
      const { data } = await api.post("payouts/my/request", payload);
      return data;
    },
    onSuccess: () => {
      notifications.show({
        title: "Success",
        message: "Payout request submitted successfully",
        color: "green",
      });
      queryClient.invalidateQueries({
        queryKey: earningsQKeys.all(),
      });
    },
    onError: (res: any) => {
      console.error("[From Request Payout Mutation]", res);
      handleErrors(res, "mutation");
    },
  });
};
